/* eslint-disable react/display-name */
import * as React from 'react';

const StarHalf = () => (
  <svg
    width="14px"
    height="14px"
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Work-in-progress" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd" strokeLinejoin="round">
      <g id="Artboard" transform="translate(-28.000000, -29.000000)">
        <g id="Group" transform="translate(28.000000, 29.000000)">
          <polygon
            id="Star-Copy-14"
            stroke="#D5D0CC"
            fill="#D5D0CC"
            points="7 10.5 2.88550323 12.663119 3.67130219 8.08155948 0.342604386 4.83688104 4.94275162 4.16844052 7 0 9.05724838 4.16844052 13.6573956 4.83688104 10.3286978 8.08155948 11.1144968 12.663119"
          />
          <path
            d="M6.65739561,2.16715534e-13 L6.65739561,10.5 L2.54289885,12.663119 L3.32869781,8.08155948 L-3.53805873e-12,4.83688104 L4.60014723,4.16844052 L6.65739561,2.14939178e-13 Z"
            id="Combined-Shape"
            stroke="#807167"
            fill="#807167"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default StarHalf;
